const BASE_URL = process.env.REACT_APP_API_KEY;
// const BASE_URL: string = 'http://178.128.61.122:8083';
// const PROFILE_URL = process.env.REACT_APP_API_KEY;
// const PROFILE_URL = 'http://178.128.61.122:8085';

export const FORM_RIDER_FIND_MANY = BASE_URL + '/rider/formRider/findMany';
export const FORM_RIDER_CONFIRM = BASE_URL + '/rider/formRider/confirmFormRider?form_rider=';
export const FORM_RIDER_DELETE = BASE_URL + '/rider/formRider/delete?Id=';

export const USER_RIDER_FIND_MANY = BASE_URL + '/rider/rider/find-many-rider-profile';
export const RIDER_FIND_MANY = BASE_URL + "/rider/rider/findMany"
export const USER_RIDER_CREATE = BASE_URL + '/rider/rider/Create';
export const USER_RIDER_DELETE = BASE_URL + '/rider/rider/delete?Id=';
export const USER_RIDER_UPDATE = BASE_URL + '/rider/rider/Update?Id=';
export const USER_RIDER_BAN = BASE_URL + '/rider/rider/banRider';
export const USER_RIDER_NEARBY = BASE_URL + '/rider/rider/nearest-rider';

export const UPDATE_RIDER_PROFILE = BASE_URL + '/profile/riderProfile/Update?Id=';
export const DELETE_PROFILE_RIDER = BASE_URL + '/profile/riderProfile/Delete?Id=';
